import React from 'react';
import { introStatement } from '../data/landing';
export function IntroStatement() {
  return <section aria-label="Studio intro" className="bg-bg px-page pt-20 md:pt-28" data-id="element-193" data-mp="1cnwisxzenuw9">
      <p className="font-serif text-[36px] font-normal leading-[1.08] tracking-[-0.01em] md:max-w-[80%] text-fg md:text-[48px]" data-id="element-194" data-mp="xygyo0udqnpj">
        {introStatement.map((s, i) => s.strong ? <span key={i} className="text-fg/40" data-id="element-195" data-mp="oxsiazhikb9h">
              {s.text}
            </span> : <span key={i} data-id="element-196" data-mp="twlwyv8je8b8">{s.text}</span>)}
      </p>
    </section>;
}